<script lang="ts">
    
    import { fly } from "svelte/transition";
    import { onDestroy } from "svelte";
    import type { Game } from "../../Model/Game";
    import { SubscriptionsManager } from "../../Model/SubscriptionsManager";
    import NumberCircle from "../Shared/NumberCircle.svelte";
    import AspectKeeper from "../Shared/AspectKeeper.svelte";

    export let game: Game;
    export let tail: number = 2;

    const gameSubscriptions = new SubscriptionsManager();

    let lastNumbers: number[] = [];

    $: setupGame(game);

    onDestroy(() => gameSubscriptions.unsubscribeAll());

    function setupGame(game: Game): void {
        gameSubscriptions.unsubscribeAll();
        if (!game) {
            lastNumbers = [];
            return;
        }
        gameSubscriptions.subscribe(game.numbers, numbers => {
            lastNumbers = numbers.slice(-(tail + 1)).reverse();
        });
    }

</script>

<AspectKeeper ratio={1.2}>
    <div class="game-historic font-bingo-number" style="--tail: {1 / tail};">
        {#each lastNumbers as number, index (number)}
            <div class="number" in:fly={{ y: -100 }} out:fly={{ y: 100 }}>
                <NumberCircle {number} featured={index == 0} fontSizeRatio={index === 0 ? undefined : 0.6} />
            </div>
        {/each}
    </div>
</AspectKeeper>

<style lang="scss">

    .game-historic {
        width: 100%;
        height: 100%;
        position: relative;
    }

    .number {
        position: absolute;
        left: 10%;
        width: 80%;
        box-sizing: border-box;
        padding: 0.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: 0.3s;
    }

    .number:nth-child(1) {
        height: 60%;
        top: 0;
        z-index: 5;

        :global(.number) {
            max-width: 320px;
        }

        & ~ .number {
            :global(.number) {
                max-width: 220px;
            }
        }

        & ~ .number:last-child {
            opacity: 0.5;
        }
    }

    @for $i from 2 through 4 {
        .number:nth-child(#{$i}) {
            height: 40%;
            top: 60%;
            width: calc(100% * var(--tail));
            left: calc(100% * var(--tail) * #{$i - 2});
        }
    }

    .number:nth-child(5) {
        height: 40%;
        top: 60%;
        width: 33.33%;
        left: 66.66%;
    }

</style>
